'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _TelephoneData = require('I18n/constants/TelephoneData');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (code) {
  var countries = _TelephoneData.allCountries;
  var countryStringsPath = 'SharedI18nStrings.countryCodes';
  var getCountryName = function getCountryName(countryCode) {
    return _I18n2.default.text(countryStringsPath + '.' + countryCode.toUpperCase());
  };
  var translatedCountries = _I18n2.default.text(countryStringsPath);

  if (translatedCountries[code.toUpperCase()]) {
    return getCountryName(code);
  }

  var countryData = countries.find(function (country) {
    return country.iso2 === code.toLowerCase();
  });
  if (countryData) {
    return countryData.name;
  }

  return _I18n2.default.text('i18nAddon.countryInfo.invalidCountryOption');
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-i18n/static-1.2379/js/internal/utils/getCountryName.js
// module id = 563
// module chunks = 3 4 5